import React from 'react';
import styled from 'styled-components';
import { Radio } from 'src/antd';
import { Typography } from 'src/ui/Typography';
import { T } from '@transifex/react';
import { MailOutlined, MobileOutlined } from '@ant-design/icons';
import { useCompany } from 'src/app/Company.store';

interface NotificationRadioProps {
  value: string;
  onChange: (value: string) => void;
  style?: React.CSSProperties;
}

const StyledRadioGroup = styled(Radio.Group)`
  width: 100%;
`;

const StyledRadio = styled(Radio)<{
  isLast: boolean;
  isActive: boolean;
}>`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 16px;
  border: 1px solid
    ${(props) => (props.isActive ? props.theme.colors.dark100 : '#d9d9d9')};
  border-radius: 2px;
  margin-bottom: ${(props) => (props.isLast ? '0' : '8px')};
`;

const RadioContent = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  margin-left: 8px;
`;

const StyledTypography = styled(Typography)`
  color: #0f3f6b;
`;

const getContentMap = () => ({
  sms: {
    icon: <MobileOutlined style={{ fontSize: 35, color: '#0F3F6B' }} />,
    title: <T _str="Phone number (SMS)" />,
  },
  email: {
    icon: <MailOutlined style={{ fontSize: 35, color: '#0F3F6B' }} />,
    title: <T _str="Email address" />,
  },
});

const NotificationRadio: React.FC<NotificationRadioProps> = ({
  value,
  onChange,
  style,
}) => {
  const { data: companyData } = useCompany();
  const contentMap = getContentMap();
  const providers = companyData.crm_enable_container_notification_providers;
  const content = providers.map(
    (type) => contentMap[type as keyof typeof contentMap]
  );

  return (
    <StyledRadioGroup
      value={value}
      onChange={(e) => onChange(e.target.value)}
      style={style}
    >
      {content.map(({ icon, title }, index) => {
        const type = providers[index];
        const isLast = index === content.length - 1;
        return (
          <StyledRadio
            key={type}
            value={type}
            isLast={isLast}
            isActive={value === type}
          >
            <RadioContent>
              {icon}
              <StyledTypography weight="medium" variant="h6">
                {title}
              </StyledTypography>
            </RadioContent>
          </StyledRadio>
        );
      })}
    </StyledRadioGroup>
  );
};

export default NotificationRadio;
